
import { message } from 'ant-design-vue'

export function copy(value) {
    navigator.clipboard.writeText(value).then(function () {
        message.success('复制成功！')
    }, function () {
        message.error('复制失败！')
    });
}